var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import React, { useEffect, useState } from "react";
import ClientSearch from "../ClientSearch";
import "@frameworks/salesjourney/stylesheets/components/Generic/SearchField1.scss";
import clientDi from "@frameworks/salesjourney/components/Features/ClientDetails/di/serviceLocator";
import { useSelector } from "react-redux";
import GenericSearch from "./GenericSearch";
var SearchClientPartner = function (props) {
    var _a = __read(useState(""), 2), searchText = _a[0], setSearchText = _a[1];
    var _b = __read(useState(null), 2), selectedClient = _b[0], setSelectedClient = _b[1];
    useEffect(function () {
        if (searchText && !selectedClient) {
            var getData_1 = setTimeout(function () {
                getClientSearchData({ searchText: searchText });
            }, 800);
            return function () { return clearTimeout(getData_1); };
        }
    }, [searchText]);
    useEffect(function () {
        if (props === null || props === void 0 ? void 0 : props.clearSearch) {
            setSearchText("");
        }
    }, [props === null || props === void 0 ? void 0 : props.clearSearch]);
    var getClientSearchData = function (searchText) {
        //setLoader(true);
        clientDi.clients.getClientSearchData({ searchText: searchText.searchText });
    };
    var _c = useSelector(function (state) { return state.Clients.ClientSearch; }), ClientSearchData = _c.reducersData.data, loader = _c.commonData.loader;
    return (React.createElement(GenericSearch, { searchText: searchText, setSearchText: function (str) {
            setSelectedClient(null);
            setSearchText(str);
            console.log("clientstr", str);
            if (!str) {
                props === null || props === void 0 ? void 0 : props.setSearchText("");
            }
        }, placeholder: "Search Account Code / UCC Code / PAN / Email / Name", parentClass: "search-input-container", searchResultChild: !selectedClient && (React.createElement(ClientSearch, { setCallbackFunction: function (client) {
                setSelectedClient(client);
                setSearchText(client.clientName);
                props === null || props === void 0 ? void 0 : props.setSearchText(client === null || client === void 0 ? void 0 : client.pan);
            }, loader: loader, clientSearchList: ClientSearchData })) }));
};
export default SearchClientPartner;
